<template>
  <figure class="hour-agg">
    <ul>
      <li v-for="a in agg" :key="a.key">
        <h4 class="subtitle">{{ a.key }}</h4>
        <p class="content">{{ a.count.toLocaleString() }}</p>
      </li>
    </ul>
  </figure>
</template>

<script>
export default {
  props: {
    agg: Array
  }
}
</script>

<style lang="scss" scoped>
$color: blue;
.hour-agg {
  ul {
    display: flex;
    justify-content: center;
    li {
      flex-grow: 0;

      display: flex;
      justify-content: center;
      flex-direction: column;

      width: 100px;
      height: 100px;
      margin: 0 20px;
      border: 3px solid $color;
      border-radius: 100%;
      padding: 15px;
      text-align: center;
      .subtitle {
        color: $color;
        margin-bottom: 0;
      }
      .content {
        font-weight: bolder;
        color: #555;
      }
    }
  }
}
</style>